/* Budli listing page: sticky filter bar (mobile) + tap-to-compare (up to 3 devices of one category). */
(function () {
  if (window.__budliListing) return;
  window.__budliListing = true;

  /* ---------- sticky filter bar ---------- */
  var wrap = document.querySelector('.facets-wrapper'), bar = wrap && wrap.querySelector('.facets-container'), tick = false;
  function offsetTop() {
    var h = document.querySelector('.shopify-section-header-sticky');
    if (!h || h.classList.contains('shopify-section-header-hidden')) return 0;
    return Math.max(0, Math.round(h.getBoundingClientRect().bottom));
  }
  function stick() {
    tick = false;
    if (!bar) return;
    if (innerWidth >= 750) { bar.classList.remove('bsf-stuck'); wrap.style.minHeight = ''; return; }
    var stuck = bar.classList.contains('bsf-stuck');
    var y = (stuck ? wrap : bar).getBoundingClientRect().top;
    var off = offsetTop();
    if (!stuck && y <= off) { wrap.style.minHeight = bar.offsetHeight + 'px'; bar.classList.add('bsf-stuck'); stuck = true; }
    else if (stuck && wrap.getBoundingClientRect().top > off) { bar.classList.remove('bsf-stuck'); wrap.style.minHeight = ''; stuck = false; }
    if (stuck) bar.style.top = off + 'px'; else bar.style.top = '';
  }
  if (bar) {
    addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(stick); } }, { passive: true });
    addEventListener('resize', stick);
    stick();
  }

  var COMPARE_ON = false;
  if (!COMPARE_ON) return;

  /* ---------- compare ---------- */
  var KEY = 'budliCompare', MAX = 3, cache = {};
  function load() { try { var a = JSON.parse(sessionStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function save(a) { try { sessionStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  function track(ev, p) { try { if (window.posthog && posthog.capture) posthog.capture(ev, p || {}); } catch (e) {} }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(c) { return '₹' + Math.round(c / 100).toLocaleString('en-IN'); }
  function getP(h) {
    if (cache[h]) return cache[h];
    return (cache[h] = fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }));
  }
  function handleOf(a) { var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/); return m ? decodeURIComponent(m[1]) : null; }

  var tray = document.createElement('aside'); tray.className = 'bcmp-tray'; tray.hidden = true; tray.setAttribute('aria-label', 'Compare devices');
  var modal = document.createElement('aside'); modal.className = 'bcmp-modal'; modal.hidden = true; modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true'); modal.setAttribute('aria-label', 'Compare devices');
  var toastEl = document.createElement('div'); toastEl.className = 'bcmp-toast'; toastEl.hidden = true; toastEl.setAttribute('role', 'status');
  document.body.appendChild(tray); document.body.appendChild(modal); document.body.appendChild(toastEl);
  var tt = 0;
  function toast(m) { toastEl.textContent = m; toastEl.hidden = false; clearTimeout(tt); tt = setTimeout(function () { toastEl.hidden = true; }, 3200); }

  function decorate(root) {
    [].forEach.call((root || document).querySelectorAll('.card-wrapper:not([data-bcmp])'), function (w) {
      w.setAttribute('data-bcmp', '1');
      var a = w.querySelector('a[href*="/products/"]'), h = a && handleOf(a), host = w;
      if (!h) return;
      var b = document.createElement('button'); b.type = 'button'; b.className = 'bcmp-btn'; b.setAttribute('data-h', h);
      b.innerHTML = '<span class="bcmp-ic" aria-hidden="true"></span><span class="bcmp-tx">Compare</span>';
      host.appendChild(b);
    });
    paint();
  }
  function paint() {
    var a = load();
    [].forEach.call(document.querySelectorAll('.bcmp-btn'), function (b) {
      var on = a.indexOf(b.getAttribute('data-h')) > -1;
      b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.querySelector('.bcmp-tx').textContent = on ? 'Added' : 'Compare';
    });
    renderTray(a);
  }
  function renderTray(a) {
    if (!a.length) { tray.hidden = true; document.documentElement.classList.remove('bcmp-on'); return; }
    var out = '<div class="bcmp-slots">';
    for (var i = 0; i < MAX; i++) {
      out += a[i] ? '<span class="bcmp-slot is-full" data-slot="' + esc(a[i]) + '"><img alt="" width="44" height="44" data-img="' + esc(a[i]) + '"><button type="button" class="bcmp-x" data-rm="' + esc(a[i]) + '" aria-label="Remove">&times;</button></span>' : '<span class="bcmp-slot" aria-hidden="true">+</span>';
    }
    out += '</div><div class="bcmp-info"><b>' + a.length + ' of ' + MAX + '</b><span>' + (a.length < 2 ? 'Add one more to compare' : 'Ready to compare') + '</span></div>' +
      '<button type="button" class="bcmp-go" data-go' + (a.length < 2 ? ' disabled' : '') + '>Compare</button><button type="button" class="bcmp-clr" data-clr>Clear</button>';
    tray.innerHTML = out; tray.hidden = false; document.documentElement.classList.add('bcmp-on');
    a.forEach(function (h) { getP(h).then(function (p) { var im = tray.querySelector('img[data-img="' + h.replace(/"/g, '') + '"]'); if (im && p && p.featured_image) im.src = p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_100x100$1$2'); }); });
  }

  function add(h) {
    var a = load();
    if (a.indexOf(h) > -1) return;
    if (a.length >= MAX) { toast('You can compare up to ' + MAX + ' devices. Remove one first.'); return; }
    getP(h).then(function (p) {
      if (!p) { toast('Could not add this device'); return; }
      if (a.length) {
        getP(a[0]).then(function (f) {
          if (f && f.type && p.type && f.type !== p.type) { toast('Compare works within one category. You have ' + f.type.toLowerCase() + ' selected.'); return; }
          commit(h);
        });
      } else commit(h);
    });
  }
  function commit(h) { var a = load(); if (a.indexOf(h) > -1 || a.length >= MAX) return; a.push(h); save(a); track('compare_add', { handle: h, count: a.length }); paint(); }
  function remove(h) { var a = load().filter(function (x) { return x !== h; }); save(a); paint(); if (!modal.hidden) { a.length < 2 ? closeModal() : openModal(); } }

  document.addEventListener('click', function (e) {
    var t = e.target; if (!t.closest) return;
    var b = t.closest('.bcmp-btn');
    if (b) { e.preventDefault(); e.stopPropagation(); var h = b.getAttribute('data-h'); load().indexOf(h) > -1 ? remove(h) : add(h); return; }
    var rm = t.closest('[data-rm]'); if (rm) { remove(rm.getAttribute('data-rm')); return; }
    if (t.closest('[data-clr]')) { save([]); paint(); return; }
    if (t.closest('[data-go]')) { openModal(); return; }
    if (t.closest('[data-close]')) { closeModal(); return; }
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) closeModal(); });

  /* ---- comparison table ---- */
  var GB = /^(\d+)\s?(GB|TB)$/i, NET = /^[2-5]G$/i, COND = ['Unboxed', 'Open Box', 'Superb', 'Like New', 'Good', 'Fair', 'Refurbished', 'Usable'];
  function toGB(t) { var m = t.match(GB); return m ? parseInt(m[1], 10) * (/tb/i.test(m[2]) ? 1024 : 1) : 0; }
  function specs(p) {
    var tags = p.tags || [], mem = tags.filter(function (t) { return GB.test(t); }).sort(function (a, b) { return toGB(b) - toGB(a); });
    var net = tags.filter(function (t) { return NET.test(t); }).sort().pop();
    var cond = '', m = (p.title || '').match(/\(([^)]*?)\s*(?:Condition)?\)\s*$/i);
    if (m && !/warranty|unboxed - |global/i.test(m[1])) cond = m[1];
    if (!cond) cond = COND.filter(function (c) { return tags.some(function (t) { return t.toLowerCase() === c.toLowerCase(); }); })[0];
    return { storage: mem[0] || '', ram: mem.length > 1 ? mem[mem.length - 1] : '', net: net || '', cond: cond || '' };
  }
  function openModal() {
    var a = load(); if (a.length < 2) return;
    modal.innerHTML = '<div class="bcmp-sheet"><div class="bcmp-head"><b>Compare devices</b><button type="button" class="bcmp-close" data-close aria-label="Close">&times;</button></div><div class="bcmp-body"><p class="bcmp-load">Loading…</p></div></div>';
    modal.hidden = false; document.documentElement.classList.add('bcmp-lock');
    Promise.all(a.map(getP)).then(function (ps) {
      ps = ps.filter(Boolean); var sp = ps.map(specs);
      var minP = Math.min.apply(null, ps.map(function (p) { return p.price; })), maxS = Math.max.apply(null, sp.map(function (s) { return toGB(s.storage); })), maxR = Math.max.apply(null, sp.map(function (s) { return toGB(s.ram); }));
      function row(label, fn, best) { return '<tr><th scope="row">' + label + '</th>' + ps.map(function (p, i) { var v = fn(p, sp[i]); return '<td' + (best && best(p, sp[i]) ? ' class="is-best"' : '') + '>' + (v || '<span class="bcmp-na">—</span>') + '</td>'; }).join('') + '</tr>'; }
      var t = '<div class="bcmp-scroll"><table class="bcmp-table"><thead><tr><th></th>' + ps.map(function (p) {
        var im = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_300x300$1$2') : '';
        return '<td><a href="' + esc(p.url) + '" class="bcmp-prod">' + (im ? '<img src="' + esc(im) + '" alt="" width="120" height="120">' : '') + '<span>' + esc(p.title) + '</span></a><button type="button" class="bcmp-rm" data-rm="' + esc(p.handle) + '">Remove</button></td>';
      }).join('') + '</tr></thead><tbody>' +
        row('Price', function (p) { return '<b>' + money(p.price) + '</b>' + (p.compare_at_price > p.price ? '<s>' + money(p.compare_at_price) + '</s>' : ''); }, function (p) { return p.price === minP && ps.length > 1; }) +
        row('You save', function (p) { return p.compare_at_price > p.price ? money(p.compare_at_price - p.price) + ' (' + Math.round((1 - p.price / p.compare_at_price) * 100) + '%)' : ''; }) +
        row('Condition', function (p, s) { return esc(s.cond); }) +
        row('Brand', function (p) { return esc(p.vendor); }) +
        row('Storage', function (p, s) { return esc(s.storage); }, function (p, s) { return toGB(s.storage) === maxS && maxS > 0 && new Set(sp.map(function (x) { return x.storage; })).size > 1; }) +
        row('RAM', function (p, s) { return esc(s.ram); }, function (p, s) { return toGB(s.ram) === maxR && maxR > 0 && new Set(sp.map(function (x) { return x.ram; })).size > 1; }) +
        row('Network', function (p, s) { return esc(s.net); }) +
        row('Availability', function (p) { return p.available ? 'In stock' : 'Sold out'; }) +
        '<tr><th></th>' + ps.map(function (p) { return '<td><a class="bcmp-view" href="' + esc(p.url) + '">View device</a></td>'; }).join('') + '</tr>' +
        '</tbody></table></div><p class="bcmp-note">Highlighted cells are the best value on that row. Open each device for full condition notes and photos.</p>';
      modal.querySelector('.bcmp-body').innerHTML = t;
      track('compare_open', { count: ps.length, handles: ps.map(function (p) { return p.handle; }).join(',') });
    });
  }
  function closeModal() { modal.hidden = true; document.documentElement.classList.remove('bcmp-lock'); }
  modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });

  decorate();
  var mt = 0;
  new MutationObserver(function () { clearTimeout(mt); mt = setTimeout(function () { decorate(); }, 150); }).observe(document.body, { childList: true, subtree: true });
})();
